module.exports = __webpack_public_path__ + "img/securityImg6.ab781d5b.png";